<template>
    <router-view />
</template>
<script>
export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name == 'ven-grade') {
            next({ name: 'ven-grade-list' });
        } else {
            next();
        }
    },
    created() {
        if (this.$route.name == 'ven-grade') {
            this.$router.push({ name: 'ven-grade-list' });
        }
    },
};
</script>
